import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Splash pages",
  "description": "",
  "published": "2007-03-31T00:00:00.000Z",
  "redirect_from": ["/blog/splash-pages/swizec/249"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Everyone has encountered a splash page in their life online, they're everywhere and they are a silent evil. Often times a company having a web page designed will insist on having a splash page without even realising what such a thing might do to their web traffic and just how bad splash pages are perceived in the community.`}</p>
    <p>{`The biggest problem with splash pages is that when a search engine's crawler encounters it all they see is a website with practically no content whatsoever so they are less likely to give it a good rank in search results. Recently I even encountered a problem when we had to manufacture content to put on the splash page because the website did not even appear in search results, let alone have a rank.`}</p>
    <p>{`Another big issue with splash pages is that they usually denote a useless site. When a website is community driven and actually has some proper and interesting content to show there usually is no splash page, just the content. Vice versa seems to go for useless websites where a company might need a splash page simply so that anyone even views their logo and such because they would not spend enough time on the crap website otherwise.`}</p>
    <p>{`Also there is the law of three clicks, where it is advised that any content is accessible via only three clicks, a splash page adds at least one of those. Personally when I see a splash and am not particularly interested already I just leave.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      